module.exports = __webpack_public_path__ + "static/media/Nicaragua.012d41fa.png";